module.exports = __webpack_public_path__ + "static/media/ps_vs_app.0d3b1527.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/ps_vs_app.png
// module id = 90
// module chunks = 0